import style from './MicroFlicker.style';

const Path1 = () => <path p="M61.0053 152.803H79.0612L72.0599 165H54L61.0053 152.803Z" />;
const Path2 = () => <path d="M107.419 82H134.379L155 118H128.052L107.419 82Z" />;
const Path3 = () => <path d="M9.00527 58.8031H27.0612L20.0599 71H2L9.00527 58.8031Z" />;
const Path4 = () => <path d="M151.419 35H178.379L199 71H172.052L151.419 35Z" />;
const Path5 = () => <path d="M78.0053 58.8031H96.0612L89.0599 71H71L78.0053 58.8031Z" />;
const Path6 = () => <path d="M103.005 105.803H121.061L114.06 118H96L103.005 105.803Z" />;
const Path7 = () => <path d="M38.4194 82H65.3785L86 118H59.0517L38.4194 82Z" />;
const Path8 = () => <path d="M147.005 58.8031H165.061L158.06 71H140L147.005 58.8031Z" />;

export default function MicroFlicker(props) {
  return (    
    <svg
      css={ style }
      viewBox="0 0 200 200"
      { ...props }
    >
      <g>
        <Path1 />
        <path d="M38.4194 82H65.3785L86 118H59.0518L38.4194 82Z" />
        <path d="M34.0053 105.803H52.0612L45.0599 118H27L34.0053 105.803Z" />
        <Path2 />
        <Path3 />
        <Path4 />
        <Path5 />
      </g>
      <g>
        <Path2 />
        <Path6 />
        <path d="M13.4194 35H40.3785L61 71H34.0518L13.4194 35Z" />
        <Path3 />
      </g>
      <g>
        <Path1 />
        <Path7 />
        <Path2 />
        <Path3 />
        <Path4 />
        <Path8 />
      </g>
      <g>
        <path d="M65.4194 129H92.3785L113 165H86.0517L65.4194 129Z" />
        <Path1 />
        <Path6 />
        <path d="M13.4194 35H40.3785L61 71H34.0517L13.4194 35Z" />
      </g>
      <g>
        <Path1 />
        <Path7 />
        <Path2 />
        <Path3 />
        <path d="M82.4194 35H109.379L130 71H103.052L82.4194 35Z" />
        <Path5 />
        <Path8 />
      </g>
    </svg>
  );
};
